import React, { useEffect, useState } from 'react'
import Layout from '../layout/Layout'
import { AddFund, DeleteFund, GetAddedFundList, UserActivePortfolio } from '../../api/myAccount'
import moment from 'moment';
import toast, { Toaster } from 'react-hot-toast';
import { Toast } from 'bootstrap';
import { useNavigate } from 'react-router-dom';
import { useDocumentTitle } from '../../utils/Common';
import { Accessibility, Check, Moon, Sun } from "lucide-react";
import { useTheme } from '../../utils/theme';
const numberToWords = (num) => {
    if (!num || num === 0) return "";

    const a = [
        "", "One", "Two", "Three", "Four", "Five", "Six", "Seven",
        "Eight", "Nine", "Ten", "Eleven", "Twelve", "Thirteen",
        "Fourteen", "Fifteen", "Sixteen", "Seventeen", "Eighteen", "Nineteen"
    ];

    const b = [
        "", "", "Twenty", "Thirty", "Forty", "Fifty",
        "Sixty", "Seventy", "Eighty", "Ninety"
    ];

    const inWords = (n) => {
        if (n < 20) return a[n];
        if (n < 100) return b[Math.floor(n / 10)] + " " + a[n % 10];
        if (n < 1000)
            return a[Math.floor(n / 100)] + " Hundred " + inWords(n % 100);
        if (n < 100000)
            return inWords(Math.floor(n / 1000)) + " Thousand " + inWords(n % 1000);
        if (n < 10000000)
            return inWords(Math.floor(n / 100000)) + " Lakh " + inWords(n % 100000);

        return inWords(Math.floor(n / 10000000)) + " Crore " + inWords(n % 10000000);
    };

    return inWords(num).trim() + " Only";
};

export default function MyAccounts() {
    const { theme } = useTheme()
    const navigate = useNavigate();
    const [GetAddedFundData, setGetAddedFundData] = useState(null);
    const [GetACtivePortfolioList, setGetACtivePortfolioList] = useState(null);
    const [HasParams, setHasParams] = useState({
        userId: localStorage.getItem("uid"),
        amt: null,
        invPortId: 1
    })
    useDocumentTitle("My Accounts");

    useEffect(() => {
        const fetchData = async () => {
            const response = await GetAddedFundList();
            const activeList = await UserActivePortfolio();
            setGetAddedFundData(response.data);
            setGetACtivePortfolioList(activeList.data);
        }
        fetchData();
    }, [])

    const handleAmtChange = (e) => {
        const value = e.target.value;

        setHasParams(prev => ({
            ...prev,
            amt: value === "" ? null : Number(value)
        }));
    };


    const handlePortChange = (type) => {
        setHasParams(prev => ({
            ...prev,
            invPortId: type,
            amt: null // logical value
        }));
    };

    const handleAddFund = async () => {
        const allowedEtfAmount = Math.round(
            GetAddedFundData?.meta?.equityFundAmount * 0.3
        );

        // ETF warning (no auto cap)
        // if (HasParams.invPortId === 2 && HasParams.amt > allowedEtfAmount) {
        //     const isConfirmed = window.confirm(
        //         `ETF investment exceeds the recommended 30% of your equity amount.\n\n` +
        //         `Recommended maximum ETF amount: ₹${allowedEtfAmount.toLocaleString("en-IN")}.\n` +
        //         `You entered: ₹${HasParams.amt.toLocaleString("en-IN")}.\n\n` +
        //         `Do you want to continue with this amount?`
        //     );

        //     if (!isConfirmed) {
        //         // Cancel → clear form
        //         setHasParams({
        //             userId: localStorage.getItem("uid"),
        //             amt: null,
        //             invPortId: 1
        //         });
        //         return;
        //     }

        //     // OK → proceed with SAME amount (no change)
        //     await submitFund(HasParams);
        //     return;
        // }

        // Normal flow
        await submitFund(HasParams);
    };



    const submitFund = async (params) => {
        try {
            const response = await AddFund(params);

            if (response.data) {
                toast.success("Fund Added Successfully");

                setHasParams({
                    userId: localStorage.getItem("uid"),
                    amt: null,
                    invPortId: 1
                });

                const addFundedList = await GetAddedFundList();
                setGetAddedFundData(addFundedList.data);
            }
        } catch (error) {
            toast.error(error?.response?.data?.message);
        }
    };



    const handleDeleteFund = async (id) => {
        const isConfirmed = window.confirm(
            "Are you sure you want to delete this fund?"
        );

        if (!isConfirmed) return;
        try {
            const response = await DeleteFund(id);
            if (response.data) {
                toast.success("Fund Deleted Successfully")
                const addFundedList = await GetAddedFundList();
                setGetAddedFundData(addFundedList.data);
            }
        } catch (error) {
            toast.error(error?.response?.data?.message);
        }
    }

    return (
        <Layout>
            <section id="create-portfolio" class="py-4">
                <div class="container">
                    <div class="row g-3 justify-content-between">
                        <div class="col-md-12">
                            <a href="/dashboard" class="text-decoration-none text-body-emphasis fs-5" aria-label="Back to dashboard"><i class="fa fa-arrow-left" aria-hidden="true"></i></a>
                        </div>
                        <div class="col-md-2">
                            <div class="d-flex gap-3 align-items-center">
                                <div class="">
                                    <h1 class="fs-4 fw-bold mb-0">My Account</h1>
                                </div>
                            </div>
                        </div>

                        <div class="col-md-12">
                            {/* <div class="rounded-3 bg-dark"> */}
                            <div
                                className={`rounded-3 ${theme === "dark" ? "text-light" : "bg-light text-dark"
                                    }`}
                                style={theme === "dark" ? { backgroundColor: "#0A0A0B" } : {}}
                            >
                                <div class="row justify-content-md-between align-items-center">
                                    <div class="col-md-2 col-6">
                                        <div className={`p-3 ${theme === "dark" ? "text-white" : "text-dark"}`}>
                                            <div>
                                                <small class="">Total Funds</small>
                                                <p class="fs-5 mb-0">{GetAddedFundData?.meta?.totalFundAmount.toLocaleString("en-IN")}</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-2 col-6">
                                        <div className={`p-3 ${theme === "dark" ? "text-white" : "text-dark"}`}>
                                            <div>
                                                <small class="">Equity Funds</small>
                                                <p class="fs-5 mb-0">{GetAddedFundData?.meta?.equityFundAmount.toLocaleString("en-IN")}</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-2 col-6">
                                        <div className={`p-3 ${theme === "dark" ? "text-white" : "text-dark"}`}>
                                            <div>
                                                <small class="">ETF Funds</small>
                                                <p class="fs-5 mb-0">{GetAddedFundData?.meta?.etfFundAmount.toLocaleString("en-IN")}</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-2 col-6">
                                        <div className={`p-3 ${theme === "dark" ? "text-white" : "text-dark"}`}>
                                            <div>
                                                <small class="">Pending Funds</small>
                                                <p class="fs-5 mb-0">{GetAddedFundData?.meta?.totalUnAllocatedFundAmount.toLocaleString("en-IN")}</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-4">
                                        <div className="p-3">
                                            <fieldset className="border-0 p-0 m-0">
                                                <legend className="visually-hidden">Select investment portfolio type</legend>
                                            {GetACtivePortfolioList?.filter((item)=> item.pacId !== 86).map((item) => {
                                                const inputId = `portfolio-type-${item.id}`;
                                                return (
                                                <div className="form-check form-check-inline" key={item.id}>
                                                    <input
                                                        id={inputId}
                                                        className="form-check-input"
                                                        type="radio"
                                                        name="inlineRadioOptions"
                                                        checked={HasParams.invPortId === item.id}
                                                        onChange={() => handlePortChange(item.id)}
                                                    />
                                                    <label htmlFor={inputId} className={`form-check-label ${theme === "dark" ? "text-light" : "text-dark"}`}>{item.invType === "equity" ? "Equity" : "ETF"}</label>
                                                </div>
                                                );
                                            })}
                                            </fieldset>


                                            {/* <div className="form-check form-check-inline">
                                                <input
                                                    className="form-check-input"
                                                    type="radio"
                                                    name="inlineRadioOptions"
                                                    checked={HasParams.invPortId === 2}
                                                    onChange={() => handlePortChange(2)}
                                                />
                                                <label className="form-check-label text-light">ETFs</label>
                                            </div> */}

                                            <div className="input-group mt-2">
                                                <span className="input-group-text">₹</span>

                                                <input
                                                    type="number"
                                                    value={HasParams.amt ?? ""}
                                                    onChange={handleAmtChange}
                                                    className="form-control fw-bold"
                                                    placeholder={
                                                        HasParams.invPortId === 2
                                                            ? "Enter ETF amount"
                                                            : "Enter Equity amount"
                                                    }
                                                    style={{ fontSize: "1rem", letterSpacing: "1px" }}
                                                    min="0"
                                                    name="investmentAmount"
                                                    aria-label={HasParams.invPortId === 2 ? "ETF investment amount" : "Equity investment amount"}
                                                    autoComplete="off"
                                                />

                                                <button
                                                    className="btn btn-primary pt-2"
                                                    onClick={handleAddFund}
                                                    disabled={!HasParams.amt || HasParams.amt <= 0}
                                                >
                                                    Add
                                                </button>
                                            </div>
                                            {HasParams.amt && (
                                                <small className={`${theme === "dark" ? "text-white" : "text-dark"} d-block mt-1`}>
                                                    {numberToWords(HasParams.amt)}
                                                </small>
                                            )}

                                        </div>

                                    </div>
                                </div>
                            </div>
                            <p class="text-muted mb-0 mt-1"><small><b>Our recommendation:</b> Your total funds should be allocated <b>60% to the Equity portfolio</b> and <b>40% to ETFs</b>.</small></p>
                            <p class="text-muted mb-0 mt-1"><small><b>Note:</b> This is not an actual fund transfer. The amount is used only to create a personalized dashboard for you.</small></p>
                            <div class="row">
                                <div class="col-md-12">
                                    <small class="d-block mt-5 mb-2 fs-6 fw-bold">Add Funds Transaction History</small>
                                    <div class="table-responsive  rounded-2">
                                        <table class="table table-hover table-striped ">
                                    
                                            <thead>
                                                <tr>
                                                    <th style={{ "minWidth": "140px" }} >Date</th>
                                                    <th style={{ "minWidth": "140px" }} class="text-end">Amount</th>
                                                    <th style={{ "minWidth": "140px" }} class="text-end">Financial Product</th>
                                                    <th style={{ "minWidth": "140px" }} class="text-end">Status</th>
                                                    <th style={{ "minWidth": "80px" }} class="text-end">Action</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {GetAddedFundData?.dataList?.map((item, index) => (
                                                    <tr>
                                                        <td>{moment(item.createdAt).format("DD MMM, YYYY")}</td>
                                                        <td class="text-end">₹ {item.amt.toLocaleString(
                                                            "en-IN",
                                                            // {
                                                            //     minimumFractionDigits: 2,
                                                            //     maximumFractionDigits: 2,
                                                            // }
                                                        )}</td>
                                                        <td class="text-end">{item.invPortfolio?.invType == "equity" ? "Equity" : "ETF"}</td>
                                                        {item.isAllocated ?
                                                            <>
                                                                <td class="text-end"><button onClick={() => { navigate("/view-fund-allocation"); localStorage.setItem("allocationId", item.id) }} class="btn btn-sm btn-outline-dark border-0"><i class="fa fa-check-circle text-success" aria-hidden="true"></i> View Allocation</button></td>
                                                                {/* <td class="text-end"><i class="fa fa-check-circle text-success" aria-hidden="true"></i> Allocated</td> */}
                                                                <td class="text-end">-</td>
                                                            </>
                                                            :
                                                            <>
                                                                <td class="text-end"><button onClick={() => { navigate("/fund-allocation"); localStorage.setItem("allocationId", item.id) }} class="btn btn-sm btn-outline-dark pt-1">Allocate Now</button></td>
                                                                <td class="text-end"><button onClick={() => handleDeleteFund(item.id)} class="btn btn-sm btn-outline-danger"><i class="fa fa-trash" aria-hidden="true"></i></button></td>
                                                            </>
                                                        }

                                                    </tr>
                                                ))}
                                                {/* <tr>
                                                    <td>25 Dec, 2025</td>
                                                    <td class="text-end">5,00,000</td>
                                                    <td class="text-end">Equity</td>
                                                    <td class="text-end"><a href="./fund-allocation.php" class="btn btn-sm btn-outline-dark pt-1">Allocate Now</a></td>
                                                    <td class="text-end"><button class="btn btn-sm btn-outline-danger"><i class="fa fa-trash" aria-hidden="true"></i></button></td>
                                                </tr>
                                                <tr>
                                                    <td>20 Dec, 2025</td>
                                                    <td class="text-end">2,50,000</td>
                                                    <td class="text-end">ETFs</td>
                                                    <td class="text-end"><i class="fa fa-check-circle text-success" aria-hidden="true"></i> Allocated</td>
                                                    <td class="text-end">-</td>
                                                </tr>
                                                <tr>
                                                    <td>08 Dec, 2025</td>
                                                    <td class="text-end">2,50,000</td>
                                                    <td class="text-end">Equity</td>
                                                    <td class="text-end"><i class="fa fa-check-circle text-success" aria-hidden="true"></i> Allocated</td>
                                                    <td class="text-end">-</td>
                                                </tr> */}
                                            </tbody>
                                        </table>
                                    </div>
                                    <small class="text-muted">
                                        <span class="fw-bold">Note: </span>Amounts marked with <i class="fa fa-check-circle text-success" aria-hidden="true"></i> are already utilized and cannot be deleted.
                                    </small>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <Toaster />
        </Layout>
    )
}
